import { SideNav } from 'ia-react-core';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import useDocumentSummary from '../../hooks/useDocumentSummary';

export interface MyDocumentsSideNavLinkProps {
  path: string;
}

const MyDocumentsSideNavLink: FC<MyDocumentsSideNavLinkProps> = ({ path }) => {
  const { t } = useTranslation('Documents');
  const { documentsCount, isVisible } = useDocumentSummary();
  if (!isVisible) {
    return null;
  }
  const count = documentsCount > 0 ? documentsCount : null;
  return (
    <SideNav.Link data-testid="MyDocuments" to={path} badgeContent={count} badgeType={t('badgeType')}> {t('title')}</SideNav.Link>
  );
};

export default MyDocumentsSideNavLink;
